import { gql } from 'graphql.macro';

export const orderTagsTemplate = gql`
    query orderTags {
        orderTags {
            _id
            name
            color
        }
    }
`;
